<template>
  <!-- <Button long  style="padding:0 6px;"></Button> -->
  <el-button type="primary" :disabled="sending" :loading="loading" @click="sendMsgCode" plain>{{ btnText }}</el-button>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  props: {
    // 账户：邮箱号、手机号
    // 如果是发送给自己的手机号就不用传值
    account: String,
    // 类型：手机/邮箱
    type: {
      type: String,
      default: "phoneNumber",
    },
    // 是否是用户发送给自己
    me: {
      type: Boolean,
      default: false,
    },
    // 是否需要滑动验证码
    nc: {
      type: Boolean,
      default: false,
    },
    // 发短信的应用
    application: {
      type: String,
      required: true,
    },
    // 发送短信前的账号验证, 参数为验证函数的回调，回调的第一个参数为错误信息
    // 如果不是发送给自己就必须传入检验函数
    validator: {
      type: Function,
      default: (callback) => {
        callback();
      }, // 默认检验通过
    },
  },
  data () {
    return {
      sending: false,
      btnText: "发送验证码",
      leftSecondsInter: null,
      loading: false, // 发送请求中
    };
  },
  computed: {
    // 类型的文字
    typeText () {
      switch (this.type) {
        case "phoneNumber":
          return "手机";
        case "email":
          return "邮箱";
        default:
          return "账号";
      }
    },

    ...mapState(["showNCTip", "ncData"]),
  },
  beforeDestroy () {
    // 页面销毁时，清除页面定时器
    if (this.leftSecondsInter) {
      clearInterval(this.leftSecondsInter);
      this.leftSecondsInter = null;
    }
  },
  methods: {
    // 手机验证码发送
    sendCodeNew (captchaVerification) {
      this.$api.sms
        .SendCodeNew(this.account, captchaVerification)
        .then(res => {
          if (res.errCode === 0) {
            this.$emit("on-success", res.data);
            this.success();
          }
        })
        .catch(err => {
          // 还原状态
          __nc.reset();
          this.SET_NC_DATA({});
          this.btnText = '发送验证码';
        })
        .finally(() => {
          this.loading = false;
        });
    },
    success () {
      this.$notify({
        title: "发送成功",
        message: `验证码已发送到您的${this.typeText}，请注意查收，谢谢！`,
        type: 'success'
      });
      this.sending = true;
      let leftSeconds = 120;
      this.btnText = `${leftSeconds}s后再获取`;
      this.leftSecondsInter = setInterval(() => {
        leftSeconds--;
        if (leftSeconds <= 0) {
          this.btnText = "发送验证码";
          this.sending = false;
          clearInterval(this.leftSecondsInter);
          // 更改滑动验证的状态
          // __nc.reset();    //没有滑动不需要更改
          // this.SET_NC_DATA({});
          return;
        }
        this.btnText = `${leftSeconds}s后再获取`;
      }, 1000);
    },

    sendMsgCode () {
      this.validator((errMsg) => {
        if (!errMsg) {
          // 需要滑动验证
          if (this.nc) {
            if (Object.keys(this.ncData).length === 0) {
              this.SET_SHOW_NC_TIP(true);
              return;
            }
            this.loading = true;
            this.btnText = "发送中···";
            if (this.type === "phoneNumber") {
              // 手机验证码用新的接口发送
              this.$emit("formPass")
              return
              this.$api.sms
                .SendCode(this.account)
                .then((res) => {
                  if (res.errCode === 0) {
                    // this.$emit("on-success", res.data);
                    this.success();
                  }
                })
                .catch((err) => {
                  // 还原状态
                  __nc.reset();
                  this.SET_NC_DATA({});
                  this.btnText = "发送验证码";
                })
                .finally(() => {
                  this.loading = false;
                });
            } else if (this.type === "email") {
              this.$api.email
                .SendCode(this.account)
                .then((res) => {
                  if (res.errCode === 0) {
                    // this.$emit("on-success", res.data);
                    this.success();
                  }
                })
                .catch((err) => {
                  // 还原状态
                  __nc.reset();
                  this.SET_NC_DATA({});
                  this.btnText = "发送验证码";
                })
                .finally(() => {
                  this.loading = false;
                });
            }
          } else {
            // 不需要滑动验证
            this.loading = true;
            this.btnText = "发送中···";
            if (this.type === "phoneNumber") {
              // 手机验证码用新的接口发送
              this.$emit("formPass")
              return
              this.$api.sms
                .SendCode(this.account)
                .then((res) => {
                  if (res.errCode === 0) {
                    this.$emit("on-success", res.data);
                    this.success();
                  }
                })
                .catch(() => {
                  this.btnText = "发送验证码";
                })
                .finally(() => {
                  this.loading = false;
                });
            } else if (this.type === "email") {
              this.$api.email
                .SendCode(this.account)
                .then((res) => {
                  if (res.errCode === 0) {
                    this.$emit("on-success", res.data);
                    this.success();
                  }
                })
                .catch(() => {
                  this.btnText = "发送验证码";
                })
                .finally(() => {
                  this.loading = false;
                });
            }
          }
        }
      });
    },

    // 更改状态
    ...mapMutations(["SET_SHOW_NC_TIP", "SET_NC_DATA"]),
  },
};
</script>

<style lang="less" scoped></style>
